import {
    addMFA,
    removeMFA,
    resendPhoneVerificationCode,
    updatePhone,
} from './AccountSecurity.commands.js';
import {
    getMfaOptions as getMfaOptionsSelector,
    getMfaType,
    getPhone,
    isLoadingMfaOptions,
    isPhoneVerified,
} from '/b2b/authentication/state/Auth.selectors.js';

import { DEFAULT_MFA_OPTIONS } from '/b2b/authentication/state/amplify/Amplify.constants.js';
import { getCodeDeliveryDetails } from '/b2b/authentication/state/amplify/Amplify.selectors.js';
import { getMfaOptions } from '/b2b/authentication/routes/SelectMFA/SelectMFA/SelectMFA.commands.js';

export const mapStateToProps = state => {
    const phone = getPhone(state);
    const mfaOptions = getMfaOptionsSelector(state);
    return {
        preferredMFA: getMfaType(state),
        mfaOptions,
        additionalMfaOptions: DEFAULT_MFA_OPTIONS.filter(option => !mfaOptions.includes(option)),
        phone,
        smsCodeDeliveryDetails: getCodeDeliveryDetails(state, 'SMS'),
        hasPhone: !!phone,
        isLoading: isLoadingMfaOptions(state),
        isPhoneVerified: isPhoneVerified(state),
    };
};

export const mapDispatchToProps = {
    getMfaOptions,
    removeMFA,
    addMFA,
    updatePhone,
    resendPhoneVerificationCode,
};
